"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfStipendAddDto = instanceOfStipendAddDto;
exports.StipendAddDtoFromJSON = StipendAddDtoFromJSON;
exports.StipendAddDtoFromJSONTyped = StipendAddDtoFromJSONTyped;
exports.StipendAddDtoToJSON = StipendAddDtoToJSON;
exports.StipendAddDtoToJSONTyped = StipendAddDtoToJSONTyped;
const StipendType_1 = require("./StipendType");
/**
 * Check if a given object implements the StipendAddDto interface.
 */
function instanceOfStipendAddDto(value) {
    if (!('stipendType' in value) || value['stipendType'] === undefined)
        return false;
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    return true;
}
function StipendAddDtoFromJSON(json) {
    return StipendAddDtoFromJSONTyped(json, false);
}
function StipendAddDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'stipendType': (0, StipendType_1.StipendTypeFromJSON)(json['stipendType']),
        'amount': json['amount'],
    };
}
function StipendAddDtoToJSON(json) {
    return StipendAddDtoToJSONTyped(json, false);
}
function StipendAddDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'stipendType': (0, StipendType_1.StipendTypeToJSON)(value['stipendType']),
        'amount': value['amount'],
    };
}
//# sourceMappingURL=StipendAddDto.js.map